function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5987 40.1129C28.5987 41.5488 27.4346 42.7129 25.9987 42.7129C24.5628 42.7129 23.3987 41.5488 23.3987 40.1129C23.3987 38.6769 24.5628 37.5129 25.9987 37.5129C27.4346 37.5129 28.5987 38.6769 28.5987 40.1129Z",
  fill: "url(#paint0_linear_9923_164525)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5983 11.7166C28.5983 13.1525 27.4342 14.3166 25.9983 14.3166C24.5623 14.3166 23.3983 13.1525 23.3983 11.7166C23.3983 10.2806 24.5623 9.11657 25.9983 9.11657C27.4342 9.11657 28.5983 10.2806 28.5983 11.7166Z",
  fill: "url(#paint1_linear_9923_164525)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M28.5991 5.36074C28.5991 6.79668 27.4351 7.96074 25.9991 7.96074C24.5632 7.96074 23.3991 6.79668 23.3991 5.36074C23.3991 3.9248 24.5632 2.76074 25.9991 2.76074C27.4351 2.76074 28.5991 3.9248 28.5991 5.36074Z",
  fill: "url(#paint2_linear_9923_164525)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.832 15.6C10.832 17.0359 9.66797 18.2 8.23203 18.2C6.79609 18.2 5.63203 17.0359 5.63203 15.6C5.63203 14.1641 6.79609 13 8.23203 13C9.66797 13 10.832 14.1641 10.832 15.6Z",
  fill: "url(#paint3_linear_9923_164525)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M43.7654 18.2C42.3294 18.2 41.1654 17.0359 41.1654 15.6C41.1654 14.1641 42.3294 13 43.7654 13C45.2013 13 46.3654 14.1641 46.3654 15.6C46.3654 17.0359 45.2013 18.2 43.7654 18.2Z",
  fill: "url(#paint4_linear_9923_164525)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6834 40.7709C13.6834 42.2068 12.5194 43.3709 11.0834 43.3709C9.64751 43.3709 8.48345 42.2068 8.48345 40.7709C8.48345 39.3349 9.64751 38.1709 11.0834 38.1709C12.5194 38.1709 13.6834 39.3349 13.6834 40.7709Z",
  fill: "url(#paint5_linear_9923_164525)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M40.8865 43.3709C39.4506 43.3709 38.2865 42.2068 38.2865 40.7709C38.2865 39.3349 39.4506 38.1709 40.8865 38.1709C42.3224 38.1709 43.4865 39.3349 43.4865 40.7709C43.4865 42.2068 42.3224 43.3709 40.8865 43.3709Z",
  fill: "url(#paint6_linear_9923_164525)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.9987 39C33.1784 39 38.9987 33.1797 38.9987 26C38.9987 18.8203 33.1784 13 25.9987 13C18.819 13 12.9987 18.8203 12.9987 26C12.9987 33.1797 18.819 39 25.9987 39ZM25.9987 41.1667C34.375 41.1667 41.1654 34.3763 41.1654 26C41.1654 17.6237 34.375 10.8333 25.9987 10.8333C17.6224 10.8333 10.832 17.6237 10.832 26C10.832 34.3763 17.6224 41.1667 25.9987 41.1667Z",
  fill: "url(#paint7_linear_9923_164525)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.9987 45.5C36.7683 45.5 45.4987 36.7695 45.4987 26C45.4987 15.2304 36.7683 6.5 25.9987 6.5C15.2291 6.5 6.4987 15.2304 6.4987 26C6.4987 36.7695 15.2291 45.5 25.9987 45.5ZM25.9987 47.6667C37.9649 47.6667 47.6654 37.9662 47.6654 26C47.6654 14.0338 37.9649 4.33333 25.9987 4.33333C14.0325 4.33333 4.33203 14.0338 4.33203 26C4.33203 37.9662 14.0325 47.6667 25.9987 47.6667Z",
  fill: "url(#paint8_linear_9923_164525)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6654 21.3972H23.9065L28.3604 27.6808V21.3972H30.332V30.6028H28.0909L23.637 24.2198V30.6028H21.6654V21.3972Z",
  fill: "url(#paint9_linear_9923_164525)"
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_9923_164525",
  x1: 4.33203,
  y1: 25.2137,
  x2: 47.6654,
  y2: 25.2137,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_9923_164525",
  x1: 4.33203,
  y1: 25.2137,
  x2: 47.6654,
  y2: 25.2137,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_9923_164525",
  x1: 4.33203,
  y1: 25.2137,
  x2: 47.6654,
  y2: 25.2137,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_9923_164525",
  x1: 4.33203,
  y1: 25.2137,
  x2: 47.6654,
  y2: 25.2137,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_9923_164525",
  x1: 4.33203,
  y1: 25.2137,
  x2: 47.6654,
  y2: 25.2137,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_9923_164525",
  x1: 4.33203,
  y1: 25.2137,
  x2: 47.6654,
  y2: 25.2137,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_9923_164525",
  x1: 4.33203,
  y1: 25.2137,
  x2: 47.6654,
  y2: 25.2137,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_9923_164525",
  x1: 4.33203,
  y1: 25.2137,
  x2: 47.6654,
  y2: 25.2137,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_9923_164525",
  x1: 4.33203,
  y1: 25.2137,
  x2: 47.6654,
  y2: 25.2137,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_9923_164525",
  x1: 4.33203,
  y1: 25.2137,
  x2: 47.6654,
  y2: 25.2137,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})));

function SvgNitron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNitron);
export default __webpack_public_path__ + "static/media/Nitron.00a10db6ef1131b0c8d38040ea93854b.svg";
export { ForwardRef as ReactComponent };